export default "__VITE_ASSET__51b17d43__"